































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {ReceiptPostOfficeParams} from "@/modules/receiptsexpenses/receiptpostoffice/params";
import {ReceiptPostOfficeStore} from "@/modules/receiptsexpenses/receiptpostoffice/store";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {LadingPaymentType} from "@/enums/type";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import ReceiptPostOfficeTable from "@/modules/receiptsexpenses/receiptpostoffice/List/ReceiptPostOfficeTable/index.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {allDebtPostOffice} from "@/modules/receiptsexpenses/receiptpostoffice/services";
import ReceiptPostOfficeExcel from "@/modules/receiptsexpenses/receiptpostoffice/List/ReceiptPostOfficeExcel/index.vue";
import TableToExcel from "@linways/table-to-excel";

@Component({
    name: "DebtPostOffice",
    components: {
        ReceiptPostOfficeExcel,
        ReceiptPostOfficeTable, LadingPaymentTypeLabel, LadingStatusLabel, PostOfficeSelector}
})
export default class extends mixins(CommonMixin) {
    params: ReceiptPostOfficeParams = new ReceiptPostOfficeParams();
    LadingPaymentType = LadingPaymentType;
    debtPostOfficesExcel = [] as any;
    isExporting = false;

    created() {
        ReceiptPostOfficeStore.updateParamsDebtPostOffice(this.params);
        ReceiptPostOfficeStore.listDebtPostOffice(ReceiptPostOfficeStore.params);
    }

    @Watch("params", {deep: true})
    onChangeParams(val: any) {
        ReceiptPostOfficeStore.updateParamsDebtPostOffice({...val, page: 1});
        ReceiptPostOfficeStore.listDebtPostOffice(ReceiptPostOfficeStore.params);
    }

    get debtPostOffices() {
        return ReceiptPostOfficeStore.ids.map((id: number) => ReceiptPostOfficeStore.data[id]);
    }

    get pagination() {
        return {
            current: ReceiptPostOfficeStore.meta.page,
            pageSize: ReceiptPostOfficeStore.meta.limit,
            total: ReceiptPostOfficeStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ReceiptPostOfficeStore.updateParamsDebtPostOffice({
            ...ReceiptPostOfficeStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        })
        ReceiptPostOfficeStore.listDebtPostOffice(ReceiptPostOfficeStore.params);
    }

    async exportExcel() {
        try {
            await this.getDataExport();
            setTimeout(() => {
                TableToExcel.convert(document.getElementById("table-excel-receipt-postoffice"), {
                    name: `Danh sách bưu cục nợ.xlsx`,
                    sheet: {
                        name: "Sheet 1"
                    }
                });
            }, 200)
        } catch (e) {
        }
    }

    async getDataExport() {
        try {
            this.isExporting = true;
            const { data } = await allDebtPostOffice(ReceiptPostOfficeStore.params);
            this.debtPostOfficesExcel = data.datas;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xuất excel lỗi");
        } finally {
            this.isExporting = false;
        }
    }
}
